// extracted by mini-css-extract-plugin
export default {"Login":"Login_Login__WxRFz","inp":"Login_inp__PC-cI","sub":"Login_sub__AAPnW"};